import { render, staticRenderFns } from "./planPromotionMapping.vue?vue&type=template&id=270ec8f0&scoped=true"
import script from "./planPromotionMapping.vue?vue&type=script&lang=js"
export * from "./planPromotionMapping.vue?vue&type=script&lang=js"
import style0 from "./planPromotionMapping.vue?vue&type=style&index=0&id=270ec8f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ec8f0",
  null
  
)

export default component.exports